export enum VilkenRoll {
    MYNDIGHET = "vilken-roll-myndighet",
    PRIVATPERSON = "vilken-roll-privatperson",
}
export enum DinMisstanke {
    FORETAG = "din-misstanke-foretag",
    PRIVATPERSON = "din-misstanke-privatperson",
}
export enum VilkenSituation {
    ARBETAR_SAMTIDIGT = "vilken-situation-arbetarsamtidigt",
    SAMMANBOENDE = "vilken-situation-sammanboende",
    FLYTT_UTOMLANDS = "vilken-situation-flyttutomlands",
    ASSISTENSERSATTNING = "vilken-situation-assistansersattning",
    STATLIGT_TANDVARDSSTOD = "vilken-situation-statligttandvardsstod",
    FORETAG_ASSISTANSERSATTNING = "vilken-situation-assistansersattning",
    PRIVAT_ANNAN = "vilken-situation-privat-annan",
    FORETAG_ANNAN = "vilken-situation-foretag-annan",
}
export enum Underrattelseskyldighet {
    JA = "underrattelseskyldighet-ja",
    NEJ = "underrattelseskyldighet-nej",
}
export enum VetPersonnummer {
    JA = "vet-personnummer-ja",
    NEJ = "vet-personnummer-nej",
}
export enum MedvetetFel {
    JA = "medvetet-fel-ja",
    NEJ = "medvetet-fel-nej",
    VETINTE = "medvetet-fel-vetinte",
}
export enum Anonym {
    JA = "anonym-ja",
    NEJ = "anonym-nej",
}
export enum AnmaldArbete {
    ANSTALLD = "anmald-arbete-anstalld",
    VERKSAMHET = "anmald-arbete-egenversamhet",
}
export enum AssistansErsattningOptions {
    ANNAT = "assistans-ersattning-annat",
    ASSISTANS_UTFORS_INTE = "assistans-ersattning-assistansutforsinte",
    FELAKTIG_REDOVISNING = "assistans-ersattning-assistenttimmarfel",
    LATSAS_BEHOV = "assistans-ersattning-latsashabehov",
}
export interface UploadedFile {
    id: string;
    file: File;
}
export interface Forsteg {
    vilkenroll: VilkenRoll | null;
    misstanke: DinMisstanke | null;
}
export interface AnnatMisstanke {
    inteRattTillErsattning: string;
    hurLangeFelUtbetalt: string;
}
export interface StatligtTandvardsstod {
    beskrivSituationen: string;
    fleraEllerSpeciellaBesok: string;
    narGjordesBesoken: string;
    namnPaTandlakare: string;
    namnPaMottagning: string;
}
export interface Utomlands {
    vilketLand: string;
    hurVetDu: string;
    narSkeddeFlytten: string;
    flyttaTillbaka: string;
    utomlandsVistelsen: string;
    bostadSverige: string;
}
export interface ForetagGenerell {
    medvetetFel: MedvetetFel | null;
    vadGorDetMedvetet: string;
    beskrivSituationen: string;
    hurVetDuAtt: string;
    lamnaUppgifterSomStodjer: string;
}
export interface PrivatpersonGenerell {
    medvetetFel: MedvetetFel | null;
    varforTrorDuDet: string;
}
export interface AssistansErsattning {
    assistansErsattningVal: AssistansErsattningOptions | null;
    vadFarPersonenHjalpMed: string;
    assistansTidInteArbetar: string;
    assistansTidAnnanSysselsattning: string;
    assistansErsattningEjBehov: string;
    ekonomiskaOegentligheter: string;
    berattaOmAssistansen: string;
    beskrivOvrigaSkal: string;
    hurLange: string;
    uppgifterForsakringskassan: string;
    andraPersoner: string;
    ovrigInformation: string;
}
export interface Kontaktuppgifter {
    anmalareVarJobbar: string;
    anmalareDittFornamn: string;
    anmalareDittEfternamn: string;
    anmalareDinTelefon: string;
    anmalareKontaktuppgift: string;
    anmalareOvrigKontaktuppgift: string;
    anmalareRelationTill: string;
    anmaldAdressOrt: string;
    anmaldAndraUppgifter: string;
    anmaldFodelsedatum: string;
    anmaldFornamn: string;
    anmaldEfternamn: string;
    anmaldPersonnummer: string;
    anmaldKontaktuppgift: string;
    foretagForetradare: string;
    foretagNamn: string;
    foretagOvrigaUppgifter: string;
    organisationsnummer: string;
    ovrigaUppgifter: string;
    villDuVaraAnonym: Anonym | null;
    vetPersonnummer: string;
}
export interface Observationer {
    situation: VilkenSituation | null;
    typAvErsattning: string;
    bilagor: string;
    vadStammerInPaPersonen: AnmaldArbete | null;
    anmaldArbete: string;
    anmaldArbeteAdress: string;
    anmaldHurOftaArbetar: string;
    anmaldBeskrivArbete: string;
    anmaldHurVetDu: string;
    anmaldBeskrivForetag: string;
    anmaldForetagIntressenter: string;
    anmaldInsynIVerksamheten: string;
    ensamstaendeAdress: string;
    ensamstaendeHurVetDu: string;
    ensamstaendeHurLange: string;
    ensamstaendeFornamn: string;
    ensamstaendeEfternamn: string;
    ensamstaendeUppgifterSambo: string;
    ensamstaendeOvrigaBostader: string;
    utomlands: Utomlands;
    assistansErsattning: AssistansErsattning;
    annatMisstanke: AnnatMisstanke;
    statligtTandvardsstod: StatligtTandvardsstod;
    foretagGenerell: ForetagGenerell;
    privatpersonGenerell: PrivatpersonGenerell;
    underrattelseskyldighet: Underrattelseskyldighet | null;
    files: Array<UploadedFile>;
}
export interface RootState {
    forsteg: Forsteg;
    kontaktuppgifter: Kontaktuppgifter;
    observationer: Observationer;
}
export interface KvittensSession extends Forsteg {
    showErrorMessage: boolean;
    date: string;
}
export interface ContainerSlot {
    isOpen: boolean;
    isSubmitted: boolean;
    isAnyFieldTouched: boolean;
    isValid: boolean;
    id: string;
    title: string;
    toggleIsOpen(): void;
    progress: number;
}
export interface ApiEmail {
    rubrik: string;
    meddelande: string;
}
